import React, { CSSProperties } from 'react';

import styles from './ProgressBadge.module.scss';

interface ProgressBadgeProps {
  badgeColor: string;
}

const ProgressBadge: React.FC<ProgressBadgeProps> = ({ badgeColor }) => (
  <>
    <g filter="url(#filter1_d_1167_8868)">
      <path
        d="M68.6818 55.318C66.9248 53.561 64.0747 53.561 62.3177 55.318C62.1967 55.439 62.1038 55.577 61.9998 55.707C61.8958 55.577 61.8028 55.439 61.6818 55.318C59.9248 53.561 57.0747 53.561 55.3177 55.318C53.5608 57.075 53.5608 59.925 55.3177 61.682L61.9998 68L68.6818 61.682C70.4388 59.925 70.4388 57.075 68.6818 55.318Z"
        className={styles.badge}
        style={{ '--badge-color': badgeColor } as CSSProperties}
      />
    </g>
    <defs>
      <filter
        id="filter1_d_1167_8868"
        x="44"
        y="46"
        width="36"
        height="36"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.189758 0 0 0 0 0.203952 0 0 0 0 0.394157 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1167_8868" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1167_8868" result="shape" />
      </filter>
    </defs>
  </>
);

export default ProgressBadge;
